import type {ExpressionElement, Expression} from '@packages/systems/wfdl-ast';
import {Expressions} from '@packages/systems/wfdl';
import {isLocalesItem} from '@packages/utilities/elementTypeUtils';

export const isInsideLocalesItem = (
  element: ExpressionElement,
  tree: Expression
) => Boolean(Expressions.closestElement(tree, element.id, isLocalesItem));
